import { PlannerConfigEntity } from '@/services/configurator/PlannerConfigTypes';
import { ConfiguratorApi } from '@/utils/ConfiguratorApi';
import { Fragment, useEffect, useState } from 'react';
import { DraftsModal } from '../drafts/DraftsModal';
import { useUser } from '@/components/providers/user-provider';
import { Button } from '@/components/ui/button';

export type DraftSelectorProps = {
  identifier: string;
  username: string;
  defaultOpen: boolean;
};

export function DraftSelector({
  identifier,
  username,
  defaultOpen,
}: DraftSelectorProps) {
  const [drafts, setDrafts] = useState<PlannerConfigEntity[]>([]);
  const [open, setOpen] = useState<boolean>(!!defaultOpen);
  const user = useUser();
  const isAdmin = user.role === 'admin';

  useEffect(() => {
    let userName: string | undefined;
    if (isAdmin) {
      userName = user.email;
    }
    ConfiguratorApi.getInstance()
      .listDraftPlanners('cte', { identifier, userName })
      .then((it) => setDrafts(it as PlannerConfigEntity[]))
      .catch((error) => console.error('Unable to fetch drafts', error));
  }, [identifier, username]);

  return (
    <Fragment>
      <Button
        onClick={() => setOpen(true)}
        disabled={!drafts || drafts.length === 0}
        variant='default'
      >
        Change Draft...
      </Button>
      <DraftsModal
        identifier={identifier}
        drafts={drafts}
        openDialog={drafts.length > 0 && open}
        setOpenDialog={setOpen}
        showExtendedInfo={isAdmin}
      />
    </Fragment>
  );
}
